export enum CommonRouteNames {
  PREFIX = 'common',
  CONTACT = 'contact',
  SURVEY = 'survey',
}
